// Reusable campaign landing-page definitions. Add a new object here and a route
// is generated automatically (see App.js). All campaign pages share the SAME
// lead database and preserve UTM attribution.
export const campaigns = [
  {
    slug: "accounting-for-medical-professionals",
    industryPreset: "Medical Professionals",
    eyebrow: "Accounting for Medical Professionals",
    headline: "Accounting built around busy medical practitioners.",
    subhead:
      "Spend your time with patients, not spreadsheets. Bonsai Financial handles the bookkeeping, tax and reporting for doctors, specialists and practices.",
    pains: [
      "Practice income and expenses that are never quite up to date",
      "Provisional tax and SARS deadlines competing with patient hours",
      "No clear picture of how the practice is actually performing",
    ],
    serviceIds: ["bookkeeping", "accounting", "tax", "payroll"],
  },
  {
    slug: "accounting-for-contractors",
    industryPreset: "Independent Contractors",
    eyebrow: "Accounting for Contractors",
    headline: "Keep your contracting income and tax in order.",
    subhead:
      "For independent contractors who want their income, expenses, VAT and tax handled properly — without the admin eating into billable time.",
    pains: [
      "Irregular income that makes tax planning stressful",
      "Uncertainty about what you can and cannot claim",
      "Falling behind on records between contracts",
    ],
    serviceIds: ["bookkeeping", "tax", "accounting"],
  },
  {
    slug: "accounting-for-consultants",
    industryPreset: "Consultants",
    eyebrow: "Accounting for Consultants",
    headline: "Straightforward accounting for independent consultants.",
    subhead:
      "Practical bookkeeping, tax and reporting so you can focus on your clients and let Bonsai Financial handle the numbers.",
    pains: [
      "Juggling invoicing, expenses and tax alone",
      "No reliable monthly view of the business",
      "SARS and compliance admin piling up",
    ],
    serviceIds: ["bookkeeping", "accounting", "tax"],
  },
  {
    slug: "accounting-for-legal-professionals",
    industryPreset: "Legal Professionals",
    eyebrow: "Accounting for Legal Professionals",
    headline: "Dependable accounting for attorneys and firms.",
    subhead:
      "Bonsai Financial provides accurate bookkeeping, tax and financial reporting support for legal professionals and practices.",
    pains: [
      "Firm finances that need careful, consistent handling",
      "Tax and compliance obligations that cannot slip",
      "Limited visibility into firm performance",
    ],
    serviceIds: ["bookkeeping", "accounting", "tax", "payroll"],
  },
  {
    slug: "bookkeeping-services",
    industryPreset: "",
    eyebrow: "Bookkeeping Services",
    headline: "Bookkeeping that keeps your business organised.",
    subhead:
      "Monthly bookkeeping, bank reconciliations and financial record maintenance to keep your business current and compliant.",
    pains: [
      "Records that are behind or disorganised",
      "Bank reconciliations that never get done",
      "No monthly rhythm to your financial admin",
    ],
    serviceIds: ["bookkeeping", "accounting"],
  },
  {
    slug: "tax-services",
    industryPreset: "",
    eyebrow: "Tax Services",
    headline: "Practical tax support for individuals and businesses.",
    subhead:
      "Tax return preparation and submission, provisional tax and SARS-related administration — led by a Tax Technician Practitioner.",
    pains: [
      "Uncertainty around tax deadlines and obligations",
      "SARS correspondence that needs handling",
      "No one to prepare and submit returns properly",
    ],
    serviceIds: ["tax", "accounting"],
  },
  {
    slug: "small-business-accounting",
    industryPreset: "Small & Medium Businesses",
    eyebrow: "Small Business Accounting",
    headline: "Accounting support that grows with your business.",
    subhead:
      "Ongoing bookkeeping, accounting, tax and reporting tailored to the size and complexity of your small or medium business.",
    pains: [
      "Wearing too many hats as an owner-manager",
      "No clear financial visibility month to month",
      "Compliance and tax admin that distracts from growth",
    ],
    serviceIds: ["bookkeeping", "accounting", "tax", "payroll", "business-support"],
  },
];

export const getCampaign = (slug) => campaigns.find((c) => c.slug === slug);
